import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Sort.svg",
  "use": "Sort.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Sort.svg\"><path d=\"M20.8335,10.4349l6.9888,9.9743a1.0274,1.0274,0,0,1-.8192,1.6225H22.0208V52.0208a2,2,0,0,1-4,0V22.0317H13.0257a1.0274,1.0274,0,0,1-.8191-1.6225l6.9888-9.9743A.9956.9956,0,0,1,20.8335,10.4349ZM51.8349,43.6325l-6.9887,9.9742a.9957.9957,0,0,1-1.6382,0l-6.9887-9.9742a1.0274,1.0274,0,0,1,.8191-1.6225h4.9823V12.0209a2,2,0,0,1,4,0V42.01H51.016A1.0273,1.0273,0,0,1,51.8349,43.6325Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol